/**
 * @flow
 * @relayHash 3ef2cb7fe5b53ee3fabdf62cf55adca9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ReceivePurchaseOrderInput = {|
  purchaseOrderId: string,
  receivedItems: $ReadOnlyArray<ReceivedItemInput>,
  notes?: ?string,
|};
export type ReceivedItemInput = {|
  purchaseOrderLineId: string,
  itemId: string,
  quantityReceived: number,
  lotNumber?: ?string,
|};
export type ReceivePurchaseOrderMutationVariables = {|
  input: ReceivePurchaseOrderInput
|};
export type ReceivePurchaseOrderMutationResponse = {|
  +receivePurchaseOrder: {|
    +success: boolean,
    +message: ?string,
    +receipt: ?{|
      +id: string,
      +receivedAt: any,
      +receivedBy: {|
        +id: string,
        +firstName: string,
        +lastName: string,
      |},
      +notes: ?string,
      +receiptLines: $ReadOnlyArray<{|
        +id: string,
        +item: {|
          +id: string,
          +itemNumber: string,
          +name: string,
        |},
        +quantityReceived: number,
        +lotNumber: ?string,
      |}>,
    |},
    +poStatus: ?string,
  |}
|};
export type ReceivePurchaseOrderMutation = {|
  variables: ReceivePurchaseOrderMutationVariables,
  response: ReceivePurchaseOrderMutationResponse,
|};
*/


/*
mutation ReceivePurchaseOrderMutation(
  $input: ReceivePurchaseOrderInput!
) {
  receivePurchaseOrder(input: $input) {
    success
    message
    receipt {
      id
      receivedAt
      receivedBy {
        id
        firstName
        lastName
      }
      notes
      receiptLines {
        id
        item {
          id
          itemNumber
          name
        }
        quantityReceived
        lotNumber
      }
    }
    poStatus
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ReceivePurchaseOrderInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "receivePurchaseOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReceivePurchaseOrderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "receipt",
        "storageKey": null,
        "args": null,
        "concreteType": "POReceipt",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "receivedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "receivedBy",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "notes",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "receiptLines",
            "storageKey": null,
            "args": null,
            "concreteType": "POReceiptLine",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "itemNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "quantityReceived",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "lotNumber",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "poStatus",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ReceivePurchaseOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ReceivePurchaseOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ReceivePurchaseOrderMutation",
    "id": null,
    "text": "mutation ReceivePurchaseOrderMutation(\n  $input: ReceivePurchaseOrderInput!\n) {\n  receivePurchaseOrder(input: $input) {\n    success\n    message\n    receipt {\n      id\n      receivedAt\n      receivedBy {\n        id\n        firstName\n        lastName\n      }\n      notes\n      receiptLines {\n        id\n        item {\n          id\n          itemNumber\n          name\n        }\n        quantityReceived\n        lotNumber\n      }\n    }\n    poStatus\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8429eb63621007dfd24bdfc686e835cc';
module.exports = node;
